<template>
  <transition v-if="showModal" name="modal">
    <div :class="{'same_address_margin': sameAddress}" class="modal-mask" @click="closeModal()">
      <div class="modal-wrapper">
        <div id="modal-container" class="modal-container" @click.stop="doNothing()">
          <template v-if="stripe.data.length > 0 && !addNewCard">
            <div class="cards_container">
              <div v-for="(card, index) of stripe.data" :key="index" class="stripe_card">
                <div>
                  <div><img v-lazy-load :data-src="getCartIcon(card.brand)" class="card_icon" alt="credit card icon"> {{ card.brand }} - ***{{ card.last4 }}</div>
                  <div class="label">
                    NAME ON CARD
                  </div>
                  <div>{{ card.name }}</div>
                  <div class="label">
                    EXPIRATION DATE
                  </div>
                  <div>{{ card.expMonth + '/' + card.expYear }}</div>
                </div>
                <div class="billing_address">
                  <div class="label">
                    BILLING ADDRESS
                  </div>
                  <div>{{ card.addressLine1 }}</div>
                  <div>{{ card.addressCity }}, {{ card.addressState }}, {{ card.addressCountry }} {{ card.addressZip }}</div>
                  <div class="strech" />
                  <div class="card_actions">
                    <div :disabled="loading && cardProcessing === card.id" class="primary_card pointer" @click="removeCard(card)">
                      Remove Card
                    </div>
                    <div v-if="card.metadata.isDefault !== 'true'" class="primary_card pointer" @click="setPrimary(card)">
                      Set As Primary
                    </div>
                    <div v-if="card.metadata.isDefault === 'true'" class="primary_card pointer primary">
                      Primary
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div>
              <div class="sub_title">
                PAYMENT INFORMATION
              </div>
              <div>
                <div class="placeholder">
                  Name on card
                </div>
                <input v-model="cardHolderName" :class="{'validation_error' : cardNameError}" class="gotit_input" placeholder="E.g David Guetta">
              </div>
              <div v-if="cardError" class="card_error">
                {{ cardError }}
              </div>
              <div class="card_element_title placeholder">
                Credit or debit card
              </div>
              <div id="card-element" class="gotit_input" :class="{'validation_error' : cardErrorValidation}" />
              <div v-if="addressHistory.length > 0" class="state">
                <p>
                  <label class="sub_title">Billing Address</label>
                  <span class="trick-select option">
                    <select v-model="selectedAddress">
                      <option v-for="address in filteredAddresses" :key="address.id" :value="address">
                        {{ address.firstName + ' ' + address.lastName + ', ' + address.street + ', ' + address.city + ', ' + address.state + ', ' + address.phone + ', ' + address.email }}
                      </option>
                    </select>
                  </span>
                </p>
              </div>
              <div v-if="addressHistory.length > 0" class="same_address">
                <div>Same as shipping address</div>
                <label class="switch">
                  <input v-model="sameAddress" :checked="sameAddress" type="checkbox" @change="toggleSameAddress()">
                  <span class="gotit_slider round" />
                </label>
              </div>
              <div v-if="!sameAddress" class="form" :class="{'address_margin_top': addressHistory.length === 0}">
                <div class="row_flex">
                  <div>
                    <span class="placeholder">Full Name:</span>
                    <input v-model="name" :class="{'validation_error' : nameError}" placeholder="Full Name" class="gotit_input">
                  </div>
                  <div>
                    <span v-if="!showInvalidEmailError" class="placeholder">Email:</span>
                    <span v-else class="placeholder invalid_email">Invalid email address:</span>
                    <input v-model="email" :class="{'validation_error' : emailError}" placeholder="Email" class="gotit_input" type="email">
                  </div>
                </div>
                <div class="row_flex">
                  <div>
                    <span class="placeholder">Address Line 1:</span>
                    <vue-google-autocomplete
                      id="map"
                      ref="ac"
                      :country="'US'"
                      class="gotit_input"
                      classname="form-control"
                      placeholder="Address Line 1"
                      @placechanged="getAddressData"
                      @keyup="inputChanged"
                    />
                  </div>
                  <div>
                    <span class="placeholder">Apartment (optional):</span>
                    <input ref="addressLineTwo" v-model="addressLine2" placeholder="Apartment, suite, etc." class="gotit_input">
                  </div>
                </div>
                <div class="row_flex">
                  <div>
                    <span class="placeholder">City:</span>
                    <input v-model="city" :class="{'validation_error' : cityError}" placeholder="City" class="gotit_input">
                  </div>
                  <div v-if="country === 'US'" class="state">
                    <p>
                      <label>State:</label>
                      <span class="trick-select option">
                        <select v-model="state" :class="{'select_validation_error' : stateError}">
                          <option value="" disabled selected>
                            Select State
                          </option>
                          <option value="AL">
                            AL
                          </option>
                          <option value="AK">
                            AK
                          </option>
                          <option value="AR">
                            AR
                          </option>
                          <option value="AZ">
                            AZ
                          </option>
                          <option value="CA">
                            CA
                          </option>
                          <option value="CO">
                            CO
                          </option>
                          <option value="CT">
                            CT
                          </option>
                          <option value="DC">
                            DC
                          </option>
                          <option value="DE">
                            DE
                          </option>
                          <option value="FL">
                            FL
                          </option>
                          <option value="GA">
                            GA
                          </option>
                          <option value="HI">
                            HI
                          </option>
                          <option value="IA">
                            IA
                          </option>
                          <option value="ID">
                            ID
                          </option>
                          <option value="IL">
                            IL
                          </option>
                          <option value="IN">
                            IN
                          </option>
                          <option value="KS">
                            KS
                          </option>
                          <option value="KY">
                            KY
                          </option>
                          <option value="LA">
                            LA
                          </option>
                          <option value="MA">
                            MA
                          </option>
                          <option value="MD">
                            MD
                          </option>
                          <option value="ME">
                            ME
                          </option>
                          <option value="MI">
                            MI
                          </option>
                          <option value="MN">
                            MN
                          </option>
                          <option value="MO">
                            MO
                          </option>
                          <option value="MS">
                            MS
                          </option>
                          <option value="MT">
                            MT
                          </option>
                          <option value="NC">
                            NC
                          </option>
                          <option value="NE">
                            NE
                          </option>
                          <option value="NH">
                            NH
                          </option>
                          <option value="NJ">
                            NJ
                          </option>
                          <option value="NM">
                            NM
                          </option>
                          <option value="NV">
                            NV
                          </option>
                          <option value="NY">
                            NY
                          </option>
                          <option value="ND">
                            ND
                          </option>
                          <option value="OH">
                            OH
                          </option>
                          <option value="OK">
                            OK
                          </option>
                          <option value="OR">
                            OR
                          </option>
                          <option value="PA">
                            PA
                          </option>
                          <option value="RI">
                            RI
                          </option>
                          <option value="SC">
                            SC
                          </option>
                          <option value="SD">
                            SD
                          </option>
                          <option value="TN">
                            TN
                          </option>
                          <option value="TX">
                            TX
                          </option>
                          <option value="UT">
                            UT
                          </option>
                          <option value="VT">
                            VT
                          </option>
                          <option value="VA">
                            VA
                          </option>
                          <option value="WA">
                            WA
                          </option>
                          <option value="WI">
                            WI
                          </option>
                          <option value="WV">
                            WV
                          </option>
                          <option value="WY">
                            WY
                          </option>
                        </select>
                      </span>
                    </p>
                  </div>
                  <div v-else>
                    <span class="state placeholder">State:</span>
                    <input v-model="state" placeholder="State / Province / district" class="state gotit_input" type="text">
                  </div>
                </div>
                <div class="row_flex">
                  <div class="country">
                    <p>
                      <label>Country:</label>
                      <span class="trick-select option">
                        <select v-model="country">
                          <option value="US">
                            United States
                          </option>
                        </select>
                      </span>
                    </p>
                  </div>
                  <div class="zip">
                    <span class="placeholder">Zip:</span>
                    <input v-model="zip" :class="{'validation_error' : zipError}" placeholder="Zip" class="gotit_input" type="tel">
                  </div>
                  <div>
                    <span class="placeholder">Phone:</span>
                    <input v-model="phone" :class="{'validation_error' : phoneError}" placeholder="Phone" class="gotit_input" type="tel">
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="strech" />
          <div class="add_credit_card_actions">
            <button v-if="addNewCard" :disabled="loading" :class="{'disabled': loading}" class="gotit_button saving" @click="addCard()">
              {{ !loading? 'Add' : 'Please wait' }}<template v-if="loading">
                <span>.</span><span>.</span><span>.</span>
              </template>
            </button>
            <button v-if="addNewCard && !addNewCardOnly" class="gotit_button back_button" @click="addNewCard = false">
              Back
            </button>
            <button v-if="!addNewCardOnly && stripe && stripe.data.length > 0 && !addNewCard" class="gotit_button" @click="addNewCardFunction()">
              Add New Card
            </button>
            <button class="gotit_button close_button" @click="showModal = false">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { Subject } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import common from '~/mixins/mixin'

export default {
  name: 'ChangeCreditCardDialogComponent',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    StripeElementCard: () => import('@vue-stripe/vue-stripe')
    // VueCreditCardField: () => import(/* webpackChunkName: "vue-credit-card-field" */'vue-credit-card-field/src/Components/InlineCreditCardField')
  },
  data () {
    return {
      showModal: false,
      stripe: null,
      sameAddress: true,
      addNewCard: false,
      state: '',
      country: 'US',
      addressData: null,
      autoCompleteStream: new Subject(),
      selectedAutocompleteAddress: null,
      items: [],
      autoCompleteAddressChanges: '',
      name: '',
      completeCardDetails: false,
      addNewCardOnly: false,
      card: {},
      city: '',
      email: '',
      street: '',
      addressLine2: '',
      phone: '',
      zip: '',
      stripeInstance: null,
      cardError: '',
      draftOrder: null,
      loading: false,
      cardHolderName: '',
      cardProcessing: '',
      addressHistory: [],
      selectedAddress: null,
      cardErrorValidation: false,
      cardNameError: false,
      nameError: false,
      cityError: false,
      phoneError: false,
      emailError: false,
      showInvalidEmailError: false,
      zipError: false,
      stateError: false,
      streetError: false,
      reg: /^(([^<>()\\[\].,;:\s@"]+(\.[^<>()\\[\].,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    }
  },
  computed: {
    filteredAddresses () {
      if (this.addressHistory) {
        return this.addressHistory.filter((address) => {
          return address.city && address.city !== 'TEMP'
        })
      } else {
        return []
      }
    }
  },
  watch: {
    selectedAutocompleteAddress (newVal, oldVal) {
      if (newVal && newVal.structured_formatting) {
        this.street = newVal.structured_formatting.main_text
        this.$store.dispatch('api/trackEvent', {
          eventName: 'autocomplete_address_clicked'
        }).then().catch()
        this.$store.dispatch('api/getAddressInfo', newVal.place_id)
          // eslint-disable-next-line camelcase
          .then((address_details) => {
            for (const detail of address_details.result.address_components) {
              if (detail.types.includes('postal_code')) {
                this.zip = detail.short_name
              } else if (detail.types.includes('administrative_area_level_1')) {
                this.state = detail.short_name
              } else if (detail.types.includes('sublocality_level_1') || detail.types.includes('sublocality')) {
                this.city = detail.short_name
              } else if (detail.types.includes('country')) {
                this.country = detail.short_name
              }
            }
          })
        const addressDetails = newVal.structured_formatting.secondary_text.split(',')
        this.processAddress(addressDetails)
        this.$refs.addressLineTwo.focus()
      } else {
        this.street = newVal
      }
    },
    autoCompleteAddressChanges (newVal, oldVal) {
      this.autoCompleteStream.next(this.autoCompleteAddressChanges)
    },
    selectedAddress (newVal, oldVal) {
      if (newVal) {
        const address = newVal
        this.name = address.firstName + ' ' + address.lastName
        this.city = address.city
        this.street = address.street
        this.state = address.state
        this.zip = address.zip
        this.phone = address.phone || ''
        this.email = address.email
        this.country = address.country || 'US'
      }
    }
  },
  mounted () {
    this.$root.$on('toggle_change_credit_card', (meta) => {
      this.loading = false
      this.sameAddress = true
      this.clearFormErrors()
      this.stripe = meta.stripe
      this.lastOrder = meta.draftOrder
      this.cardError = ''
      this.addNewCardOnly = meta.addNewCardOnly
      if (this.lastOrder && this.lastOrder.deliverCity !== 'TEMP') {
        this.name = this.lastOrder.deliverFullName
        this.city = this.lastOrder.deliverCity
        this.street = this.lastOrder.deliverStreet
        this.state = this.lastOrder.deliverState
        this.zip = this.lastOrder.deliverZipCode
        this.phone = this.lastOrder.deliverPhone || ''
        this.email = this.lastOrder.deliverEmail
        if (this.lastOrder.deliverCountry === 'USA') {
          this.country = 'US'
        } else {
          this.country = this.lastOrder.deliverCountry || 'US'
        }
      }

      if (this.addNewCardOnly) {
        this.addNewCardFunction()
      } else {
        this.addNewCard = false
      }
      this.showModal = true
      this.initData()
      this.autoCompleteStream
        .pipe(debounceTime(400))
        .subscribe((street) => {
          if (street === '' || street.length < 4) {
            this.items = []
            return
          }
          this.$store.dispatch('api/trackEvent', {
            eventName: 'autocomplete_address_api_call',
            params: {
              chars: this.autoCompleteAddressChanges.length
            }
          }).then().catch()
          this.$store.dispatch('api/getAddressAutoComplete', this.autoCompleteAddressChanges)
            .then((result) => {
              this.items = []
              for (const prediction of result.predictions) {
                const place = {}
                place.text = prediction.description
                place.place = prediction
                this.items.push(place)
              }
            })
            .catch(error => console.log('error', error))
        })
    })
  },
  methods: {
    processAddress (addressDetails) {
      for (const addressDetailsKey in addressDetails) {
        if (isNaN(addressDetails[addressDetailsKey])) {
          const detail = addressDetails[addressDetailsKey].trim()
          if (detail === 'USA') {
            this.country = detail
          } else if (detail.length === 2) {
            this.state = detail
          } else {
            this.city = detail
          }
        } else {
          // some number, zip?
        }
      }
    },
    customFilter (item, queryText, itemText) {
      return true
    },
    fetchAutoCompleteAddress (search) {
      if (search) {
        this.autoCompleteAddressChanges = search
        this.street = search
        this.$store.dispatch('api/trackEvent', {
          eventName: 'autocomplete_address_typed',
          params: {
            chars: this.autoCompleteAddressChanges.length
          }
        }).then().catch()
      }
    },
    inputChanged (newInput) {
      this.street = this.$refs.ac.autocompleteText
      this.$store.dispatch('api/trackEvent', {
        eventName: 'cc_autocomplete_address_typed',
        params: {
          chars: this.street.length
        }
      }).then().catch()
    },
    getAddressData (data) {
      this.$store.dispatch('api/trackEvent', {
        eventName: 'cc_autocomplete_address_clicked'
      }).then().catch()
      this.addressData = data
      this.state = data.administrative_area_level_1
      if (data.country !== 'United States') {
        this.countries.push({ name: data.country, value: data.country })
        this.country = data.country
      } else {
        this.country = 'US'
      }
      this.city = data.locality
      this.zip = data.postal_code
      if (this.addressData == null) {
        this.addressData = { street_number: '', route: this.street }
      }
      if (this.addressData.street_number) {
        this.selectedAutocompleteAddressStr = this.addressData.street_number + ' '
      } else {
        this.selectedAutocompleteAddressStr = ''
      }
      if (this.addressData.route) {
        this.selectedAutocompleteAddressStr += this.addressData.route
      }

      this.$refs.addressLineTwo.focus()
      this.selectedAutocompleteAddress = this.selectedAutocompleteAddressStr
      this.street = this.selectedAutocompleteAddress
      setTimeout(() => {
        if (this.$refs.ac) {
          this.$refs.ac.update(this.selectedAutocompleteAddress)
        }
      }, 600)
    },
    isFormValid () {
      return this.name.trim() &&
        this.cardHolderName.trim() &&
        this.completeCardDetails &&
        this.city.trim() &&
        this.street.trim() &&
        this.state.trim() &&
        this.zip.trim() &&
        this.email.trim() &&
        this.isEmailValid(this.email) &&
        this.phone.trim()
    },
    clearFormErrors () {
      this.cardErrorValidation = false
      this.cardNameError = false
      this.nameError = false
      this.cityError = false
      this.phoneError = false
      this.emailError = false
      this.showInvalidEmailError = false
      this.zipError = false
      this.stateError = false
      this.streetError = false
    },
    async completeAddingCard (data) {
      let token
      try {
        token = await this.stripeInstance.createToken(this.card, data)
      } catch (e) {
        this.$store.dispatch('api/trackEvent', {
          eventName: 'add_credit_card_failed',
          params: {
            path: this.$route.path,
            error: JSON.stringify(e)
          }
        }).then().catch()
      }
      if (token && token.token) {
        const cardAddedData = await this.$store.dispatch('api/addCreditCard', { sourceToken: token.token.id })
        this.loading = false
        if (cardAddedData.error) {
          this.cardError = cardAddedData.errorDescription
        } else {
          if (!this.stripe || this.stripe.data.length === 0) {
            this.$store.dispatch('api/trackEvent', {
              eventName: 'add_first_credit_card',
              params: {
                path: this.$route.path
              }
            }).then().catch()
          } else {
            this.$store.dispatch('api/trackEvent', {
              eventName: 'credit_card_added',
              params: {
                path: this.$route.path
              }
            }).then().catch()
          }
          this.loading = false
          this.complete = true
          this.$emit('onCardAdded')
          this.showModal = false
        }
      } else {
        this.$store.dispatch('api/trackEvent', {
          eventName: 'add_credit_card_failed',
          params: {
            path: this.$route.path
          }
        }).then().catch()
        this.cardError = 'Some Error Occured'
        this.loading = false
      }
    },
    async setPrimary (card) {
      this.loading = true
      this.stripe.data.forEach((cc, index) => {
        if (cc.id === card.id) {
          cc.metadata.isDefault = 'true'
        } else {
          delete cc.metadata.isDefault
        }
        return cc
      })
      this.stripe.data = this.stripe.data.splice(0)

      // eslint-disable-next-line no-unused-vars
      const edit = await this.$store.dispatch('api/editCreditCard', { sourceId: card.id })
      this.$store.dispatch('api/trackEvent', {
        eventName: 'credit_card_edited',
        params: {
          path: this.$route.path
        }
      }).then().catch()
      this.loading = false
      this.$emit('onCardAdded')
    },
    async removeCard (card) {
      this.cardProcessing = card.id
      this.loading = true
      let indexToRemove = -1
      // eslint-disable-next-line no-unused-vars
      const removeResponse = await this.$store.dispatch('api/removeCreditCard', { sourceId: card.id })
      this.$store.dispatch('api/trackEvent', {
        eventName: 'credit_card_removed',
        params: {
          path: this.$route.path
        }
      }).then().catch()
      for (let i = 0; i < this.stripe.data.length; i++) {
        if (this.stripe.data[i].id === this.cardProcessing) {
          indexToRemove = i
        }
      }
      this.stripe.data.splice(indexToRemove, 1)
      this.cardProcessing = ''
      this.$emit('onCardAdded')
      this.loading = false
    },
    toggleSameAddress () {
      if (this.sameAddress && this.selectedAddress && this.selectedAddress.deliverCity !== 'TEMP') {
        this.name = this.selectedAddress.firstName + ' ' + this.selectedAddress.lastName
        this.city = this.selectedAddress.city
        this.street = this.selectedAddress.street
        this.state = this.selectedAddress.state
        this.zip = this.selectedAddress.zip
        this.phone = this.selectedAddress.phone || ''
        this.email = this.selectedAddress.email
        this.country = this.selectedAddress.country || 'US'
      } else {
        this.name = ''
        this.city = ''
        this.street = ''
        this.state = ''
        this.zip = ''
        this.phone = ''
        this.email = ''
        this.country = 'US'
      }
    },
    addNewCardFunction () {
      this.addNewCard = true
      this.initData()
    },
    initData () {
      if (!this.stripeInstance) {
        this.stripeInstance = window.Stripe('pk_live_bRnmZGITRFw9XTj8s0Xz5tMI')
      }
      /* this.stripeInstance.createSource({
        type: 'klarna',
        amount: 816,
        currency: 'eur',
        klarna: {
          product: 'payment',
          purchase_country: 'DE'
        },
        source_order: {
          items: [{
            type: 'sku',
            description: 'Grey cotton T-shirt',
            quantity: 2,
            currency: 'eur',
            amount: 796
          }, {
            type: 'tax',
            description: 'Taxes',
            currency: 'eur',
            amount: 20
          }, {
            type: 'shipping',
            description: 'Free Shipping',
            currency: 'eur',
            amount: 0
          }]
        }
      }) */
      if (!(this.stripe && this.stripe.data.length > 0 && !this.addNewCard)) {
        setTimeout(() => {
          const elements = this.stripeInstance.elements()
          this.card = elements.create('card')
          // Add an instance of the card Element into the `card-element` <div>
          this.card.mount('#card-element')

          this.card.addEventListener('change', (event) => {
            this.completeCardDetails = event.complete
          })
        }, 0)
      }
      if (!this.stripe || this.stripe.data.length === 0) {
        this.selectedPaymentMethod = 'credit_card'
        this.$store.dispatch('api/trackEvent', {
          eventName: 'start_add_first_credit_card',
          params: {
            path: this.$route.path
          }
        }).then().catch()
      } else {
        this.$store.dispatch('api/trackEvent', {
          eventName: this.addNewCard ? 'start_add_credit_card' : 'start_edit_credit_card',
          params: {
            path: this.$route.path
          }
        }).then().catch()
      }
      this.$store.dispatch('api/getAddressesHistoryFromCache').then((addressHistory) => {
        this.addressHistory = addressHistory
        if (this.addressHistory.length > 0) {
          this.sameAddress = true
          this.selectedAddress = this.addressHistory[0]
        } else {
          this.sameAddress = false
        }
      }).catch()
    },
    closeModale () {
      if (this.loading) {
        return
      }
      this.showModal = false
    },
    doNothing () {

    },
    closeModal () {
      if (!this.loading) {
        this.showModal = false
      }
    },
    isEmailValid (email) {
      return this.reg.test(email)
    },
    async addCard () {
      this.clearFormErrors()
      if (!this.isFormValid()) {
        if (!this.completeCardDetails) {
          this.cardErrorValidation = true
        }
        if (!this.cardHolderName.trim()) {
          this.cardNameError = true
        }
        if (!this.name.trim()) {
          this.nameError = true
        }
        if (!this.city) {
          this.cityError = true
        }
        if (!this.street) {
          this.streetError = true
        }
        if (!this.state) {
          this.stateError = true
        }
        if (!this.zip) {
          this.zipError = true
        }
        if (!this.phone) {
          this.phoneError = true
        }
        if (!this.email || !this.isEmailValid(this.email)) {
          this.emailError = true
        }
        if (this.email && !this.isEmailValid(this.email)) {
          this.showInvalidEmailError = true
        }
        return
      }
      this.loading = true
      this.cardError = ''
      const data = {
        name: this.cardHolderName.trim(),
        address_city: this.city.trim(),
        address_zip: this.zip.trim(),
        address_country: this.country.trim(),
        address_state: this.state.trim(),
        address_line1: this.street.trim(),
        address_line2: this.addressLine2.trim()
      }

      if (this.$store.state.localStorage.currentUser.id < 0) {
        // const isUserExists = await this.$store.dispatch('api/isUserExists', { email: this.email, phone: this.phone })
        const isUserExists = false
        if (!isUserExists || isUserExists) {
          const gotitUser = await this.$store.dispatch('api/register', {
            password: 'AUTO_' + new Date().getTime(),
            email: this.email.trim(),
            name: this.name.trim(),
            phone: this.phone.trim(),
            street: this.street.trim(),
            city: this.city.trim(),
            state: this.state.trim(),
            country: this.country.trim(),
            zip: this.zip.trim()
          })
          this.$store.dispatch('api/trackEvent', {
            eventName: 'registration_complete_during_credit_card',
            params: {
              path: this.$route.path,
              registration_method: 'email',
              userId: gotitUser[0].id
            }
          }).then().catch(() => {
            this.loading = false
          })
          common.methods.handleCurrentUserResult(this, gotitUser)
          await this.completeAddingCard(data)
        } else {
          this.$root.$emit('show_dialog', {
            title: 'Seems like you already registered to GOTit',
            message: 'Do you want to login into your existing account to follow up your order?, or continue purchase with a new account',
            positiveButton: 'Login my account',
            positiveButtonAction: () => {
              this.$root.$emit('toggle_login_menu', {
                cancelable: true
              })
            },
            negativeButton: 'Continue',
            negativeButtonAction: async () => {
              const gotitUser = await this.$store.dispatch('api/register', {
                password: 'AUTO_' + new Date().getTime(),
                email: this.email.trim(),
                name: this.name.trim(),
                phone: this.phone.trim(),
                street: this.street.trim(),
                city: this.city.trim(),
                state: this.state.trim(),
                country: this.country.trim(),
                zip: this.zip.trim()
              })
              this.$store.dispatch('api/trackEvent', {
                eventName: 'registration_complete_during_credit_card',
                params: {
                  path: this.$route.path,
                  registration_method: 'email',
                  userId: gotitUser[0].id
                }
              }).then().catch(() => {
                this.loading = false
              })
              common.methods.handleCurrentUserResult(this, gotitUser)
              await this.completeAddingCard(data)
            }
          })
        }
      } else {
        await this.completeAddingCard(data)
      }
    },
    getCartIcon (brand) {
      // Express, Diners Club, Discover, JCB, MasterCard, UnionPay, Visa, or Unknown.
      switch (brand.toLowerCase()) {
        case 'visa':
          return '/visa.svg'
        case 'express':
          return '/american-express.svg'
        case 'master card':
          return '/mastercard.svg'
        case 'diners club':
          return '/mastercard.svg'
        case 'discover':
          return '/mastercard.svg'
        case 'jcb':
          return '/mastercard.svg'
        case 'masterCard':
          return '/mastercard.svg'
        case 'unionpay':
          return '/mastercard.svg'
        default:
          return '/visa.svg'
      }
    }
  }
}
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 99998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .mobile_design .modal-wrapper, .mobile_design .modal-mask {
    display: flex;
    align-items: flex-end;
  }

  .modal-container {
    width: 900px;
    min-height: 370px;
    margin: 0px auto;
    display: flex;
    flex-direction: column;
    padding: 20px 1em;
    background-color: white;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    /*font-family: HKGroteskRegular, serif;*/
  }

  .mobile_design .modal-container {
    width: 100%;
    max-height: 70%;
    position: fixed;
    overflow: scroll;
    display: block;
    padding-bottom: calc(50px + 2em);
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .card_icon {
    width: 30px;
  }

  .save_button {
    margin-right: 4em;
  }

  .save_button_layout {
    display: flex;
    margin-top: 1em;
    flex-direction: row;
    align-items: center;
  }

  .please_wait {
    color: #198e15;
    font-size: 1.5em;
  }

  .state {
    /*padding-top: 1em;*/
  }

  .country select, .state select {
    background: url("/ic_dropdown.svg") #EBECED no-repeat calc(100% - 12px) 50%;
    border: 0;
  }

  /*.state select {*/
  /*  background: url("/ic_dropdown.svg") #EBECED no-repeat calc(100% - 12px) 50%;*/
  /*  border: 0;*/
  /*  padding: 0.5em;*/
  /*  height: 39px;*/
  /*}*/

  .same_address {
    display: flex;
    align-items: center;
    justify-items: center;
    margin-top: 0.6em;
  }
  .same_address > div {
    margin-right: 1em;
  }

  .same_address .vs-switch {
    display: inline;
  }

  .card_error {
    color: red;
  }

  .add_credit_card_actions {
    margin-top: 1em;
    display: inline-flex;
  }

  .mobile_design .add_credit_card_actions {
    position: fixed;
    bottom: 0;
    padding-bottom: 20px;
    height: calc(58px + 1em);
    padding-top: 1em;
    background: white;
    width: 100% !important;
  }

  .mobile_design .strech.regular {
    margin-bottom: calc(38px + 20px);
  }

  .cards_container {
    display: grid;
    grid-template-columns: repeat(2, 400px);
    justify-items: center;
    justify-content: space-between;
  }

  .mobile_design .cards_container {
    display: block;
    /*flex-direction: column;*/
    overflow: scroll;
    height: calc(100% - 20px - 38px);
    margin-bottom: calc(20px + 38px);
  }

  .stripe_card {
    padding: 1em;
    margin-bottom: 1em;
    display: flex;
    width: 400px;
    flex-direction: row;
    font-size: 13px;
    box-shadow: 1px 1px 4px 0px rgba(0,0,0,0.2);
    background-color: white;
    border-radius: 5px;
    /*font-family: 'HKGroteskRegular', serif;*/
  }

  .mobile_design .stripe_card {
    height: 198px !important;
    width: 98% !important;
    margin-left: 0.2em;
    /*margin-right: 0.2em;*/
  }

  .stripe_card > div {
    flex-grow: 1;
  }
  .mobile_design .stripe_card > div {
    /*flex-grow: 0;*/
    width: 30%;
  }

  .mobile_design .stripe_card:last-child {
    /*flex-grow: 1;*/
    width: 70%;
  }

  .label {
    font-size: 10px;
    color: #91969c;
    line-height: 18px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    padding: 0;
    font-weight: 500;
  }

  .primary_card {
    line-height: 31px;
    height: 33px;
    vertical-align: middle;
    box-shadow: none;
    font-size: 13px;
    color: #434649;
    border-color: #EDEEF0;
    background: #EDEEF0;
    display: inline-block;
    border-radius: 5px;
    padding: 0 13px;
    font-weight: bold;
    text-align: center;
    border-width: 1px;
    border-style: solid;
  }

  .mobile_design .primary_card {
    height: unset;
    margin-top: 0.3em;
  }

  .primary_card[disabled] {
    background: #f2f2f2 !important;
    border-color: #f2f2f2 !important;
    box-shadow: none;
    color: #CDCFD1;
    text-shadow: none;
    cursor: default;
  }

  .billing_address {
    display: flex;
    flex-direction: column;
  }

  .mobile_design .billing_address {
    margin-left: 1em;
  }

  .card_actions {
    text-align: right;
  }

  .mobile_design .card_actions {
    display: flex;
    flex-direction: column;
    text-align: left;
  }

  .primary {
    background-color: #ed4956;
    color: white;
    cursor: unset;
  }

  .back_button {
    margin-left: 1em;
  }

  .add_new_card_top {
    /*font-family: HKGroteskBold, serif;*/
    font-weight: bold;
    font-size: 1.3em;
  }

  .placeholder {
    display: block;
    /*margin-bottom: 0.4em;*/
  }

  .card_element_title {
    margin-top: 1em;
  }

  .disabled {
    opacity: 0.5;
    cursor: unset;
  }

  .sub_title {
    /*margin-top: 2em;*/
    margin-bottom: 1em;
    /*font-family: HKGroteskBold;*/
    font-weight: bold;
  }

  .close_button {
    margin-left: 1em;
  }

  .state.placeholder {
    margin-bottom: 2px;
  }

  .state.gotit_input {
    height: 39px;
  }

  .form {
    display: flex;
    flex-direction: column;
  }

  .state.placeholder {
    margin-bottom: 2px;
  }

  .state.gotit_input {
    height: 39px;
  }

  .row_flex {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
  }

  .row_flex > div {
    flex-grow: 1;
    max-width: 49%;
  }
  .row_flex > div:last-child {
    /*margin-left: 1em;*/
  }

  .row_flex > div.zip {
    min-width: 80px;
  }
  .country {
    width: 49%;
  }

  .zip {
    width: 80px !important;
    margin-left: 1em;
    margin-right: 1em;
  }

  @keyframes blink {
    /**
     * At the start of the animation the dot
     * has an opacity of .2
     */
    0% {
      opacity: .2;
    }
    /**
     * At 20% the dot is fully visible and
     * then fades out slowly
     */
    20% {
      opacity: 1;
    }
    /**
     * Until it reaches an opacity of .2 and
     * the animation can start again
     */
    100% {
      opacity: .2;
    }
  }

  .saving span {
    /**
     * Use the blink animation, which is defined above
     */
    animation-name: blink;
    /**
     * The animation should take 1.4 seconds
     */
    animation-duration: 1.4s;
    /**
     * It will repeat itself forever
     */
    animation-iteration-count: infinite;
    /**
     * This makes sure that the starting style (opacity: .2)
     * of the animation is applied before the animation starts.
     * Otherwise we would see a short flash or would have
     * to set the default styling of the dots to the same
     * as the animation. Same applies for the ending styles.
     */
    animation-fill-mode: both;
  }

  .saving span:nth-child(2) {
    /**
     * Starts the animation of the third dot
     * with a delay of .2s, otherwise all dots
     * would animate at the same time
     */
    animation-delay: .2s;
  }

  .saving span:nth-child(3) {
    /**
     * Starts the animation of the third dot
     * with a delay of .4s, otherwise all dots
     * would animate at the same time
     */
    animation-delay: .4s;
  }

  .address_margin_top {
    margin-top: 1em;
  }

  .modal-container input:focus {
    outline: 1px solid #f61948;
  }

  .mobile_design .modal-container input:focus{
    outline: 1px solid #f61948;
  }
</style>
